import { Component, OnInit, ViewChild,ElementRef} from '@angular/core';
import { Router } from '@angular/router';
import { CustomCodeComponent } from '../custom-code.component';
import { CustomCodeService } from '../custom-code.service';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
@Component({
  selector: 'app-customcode-list',
  templateUrl: './customCode-list.component.html',
  styleUrls: ['./customCode-list.component.css'],
})

export class CustomCodeListComponent implements OnInit{
   horizontalPosition:MatSnackBarHorizontalPosition= 'end';
   verticalPosition: MatSnackBarVerticalPosition = 'top';
    constructor(private router: Router, private customCodeService: CustomCodeService,  private _snackBar:MatSnackBar){
    }
    
    loginUserDetails :any
    ngOnInit(): void {
    this.loginUserDetails = JSON.parse(
      localStorage.getItem('loginUserDetails')
    );
    this.getCustomCodes();
  }
    
  customCodes: any[] = [];
  getCustomCodes(){
    const merchantUuid = this.loginUserDetails.merchant_id; 
    this.customCodeService.getCustomCodeList(merchantUuid).subscribe(
      (response) => {
        this.customCodes = response.body.data;
      },
      (error) => {
        this._snackBar.open(error.error.message, 'close', {
          duration: 3000,
          horizontalPosition: this.horizontalPosition,
          verticalPosition: this.verticalPosition
        });
      }
    );
  }

  goToCustomCode(customCode){
    this.router.navigateByUrl('custom-code/edit/' + customCode);
  }
}